// extracted by mini-css-extract-plugin
export var cardIcon = "_8q-5";
export var cardIconUnframed = "_8q-9";
export var checkboxCard = "_8q-0";
export var checkboxCardSelected = "_8q-4";
export var disabled = "_8q-2";
export var interactive = "_8q-1";
export var outerBorder = "_8q-3";
export var spacerMedium = "_8q-8";
export var spacerSmall = "_8q-7";
export var spacerXsmall = "_8q-6";